/*
 * Páginas de comunidade: Sobre (/about), Usuários (/u) e Grupos
 * (/g, /g/:nome). Aqui ficam os pontos de entrada nas outras áreas: os links
 * no menu "Mais" da barra lateral e os grupos clicáveis no perfil.
 */
import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import UserCard from 'flarum/forum/components/UserCard';
import LinkButton from 'flarum/common/components/LinkButton';
import Link from 'flarum/common/components/Link';
import Icon from 'flarum/common/components/Icon';
import CanelaSidebar from '../../components/CanelaSidebar';
import { forumBool, t } from '../../utils/settings';
import { groupsEnabled, groupUrl } from './groups';
import { guidelinesEnabled } from './AboutNav';
export default function installCommunity() {
  extendSidebarMore();
  extendProfileGroups();
}
function extendSidebarMore() {
  extend(CanelaSidebar.prototype, 'moreItems', function (items) {
    // Logo abaixo de Configurações (80) e acima dos atalhos (10), na ordem do
    // menu "Mais".
    if (forumBool('canelaAboutEnabled', true)) {
      items.add('canelaAbout', m(LinkButton, {
        href: app.route('canela.about'),
        icon: "fas fa-circle-info"
      }, t('community.about.title')), 75);
    }

    // "Diretrizes" (o antigo "FAQ" do menu).
    if (guidelinesEnabled()) {
      items.add('canelaGuidelines', m(LinkButton, {
        href: app.route('canela.guidelines'),
        icon: "fas fa-circle-question"
      }, t('community.guidelines.title')), 74.5);
    }
    if (groupsEnabled()) {
      items.add('canelaGroups', m(LinkButton, {
        href: app.route('canela.groups'),
        icon: "fas fa-user-group"
      }, t('community.groups.title')), 74);
    }

    // Sem a permissão de listar usuários, o link levaria a uma página vazia.
    if (forumBool('canelaDirectoryEnabled', true) && forumBool('canelaCanViewDirectory', false)) {
      items.add('canelaUsers', m(LinkButton, {
        href: app.route('canela.users'),
        icon: "fas fa-users"
      }, t('community.users.title')), 73);
    }
  });
}

/**
 * As pílulas de grupo do cartão do perfil (item `canelaGroups`, posto pela
 * área do perfil) viram links para /g/:nome. Só troca o item quando ele
 * existe: o desenho das pílulas é da área do perfil — aqui elas só ganham o
 * link —, e por isso esta instalação precisa vir depois da do perfil.
 */
function extendProfileGroups() {
  extend(UserCard.prototype, 'contentItems', function (items) {
    if (!items.has('canelaGroups') || !groupsEnabled() || !forumBool('canelaGroupsProfileLinks', true)) return;

    // O core 2.x-dev tipa o attr como `userd` (erro de digitação), mas passa `user`.
    const user = this.attrs.user;
    const groups = (user.groups() || []).filter(group => !!group);
    items.setContent('canelaGroups', m("ul", {
      className: "CanelaUserHero-groups"
    }, groups.map(group => m("li", {
      className: "CanelaGroupPill CanelaGroupPill--link",
      style: group.color() ? {
        '--group-color': group.color()
      } : undefined
    }, m(Link, {
      href: groupUrl(group),
      className: "CanelaGroupPill-link"
    }, group.icon() ? m(Icon, {
      name: group.icon(),
      className: "CanelaGroupPill-icon"
    }) : m("span", {
      className: "CanelaGroupPill-dot"
    }), m("span", {
      className: "CanelaGroupPill-name"
    }, group.nameSingular()))))));
  });
}
flarum.reg.add('ramon-canela', 'forum/features/community', installCommunity);